import cn from 'classnames';
import { CCShiftOptionType, PCCOnCallResource } from '@lp/features/Scheduler/SchedulerClinicalCoordinators/types';
import { SchedulerDayColumn, ShiftSiblingData } from '@lp/features/Scheduler/types';
import { shiftButtonHoverClassname } from '@lp/features/Scheduler/constants';
import { CCShiftCell, CCShiftEmptyCell } from '@lp/features/Scheduler/SchedulerClinicalCoordinators/components';
import { PCCOnCallResourceCellItem } from '@lp/features/Scheduler/SchedulerClinicalCoordinators/components/PCCScheduleGrid/components/index';
import { DayGridCellWrapper } from '@lp/features/Scheduler/components';
import { CCShift, CCShiftSelectPayload } from '@/api/apis/resources/schedule';
import { NameByValue } from '@/types';

type PCCDayCellProps = {
  myId: string;
  column: SchedulerDayColumn;
  shiftData: CCShift;
  dropdownList: NameByValue<CCShiftOptionType>[];
  siblingData?: ShiftSiblingData;
  onCallResources?: PCCOnCallResource[];
  isEditable: boolean;
  canReset: boolean;
  isPersonalView?: boolean;
  onShiftChange: (shiftPayload?: CCShiftSelectPayload) => void;
};

export const PCCDayCell = ({
  myId,
  column,
  shiftData,
  dropdownList,
  siblingData,
  onCallResources,
  isEditable,
  canReset,
  isPersonalView,
  onShiftChange,
}: PCCDayCellProps) => {
  const disabled = isPersonalView ? !isEditable : true;
  const readonly = disabled || !column.isCurrentMonth || column.isPast;

  return (
    <DayGridCellWrapper column={column}>
      {isPersonalView ? (
        <div
          className={cn('static px-2 pb-2 h-full', {
            'ps-0': siblingData?.hasPrev,
            'pe-0': siblingData?.hasNext,
          })}
        >
          {shiftData ? (
            <CCShiftCell
              shiftData={shiftData}
              dropdownList={dropdownList}
              siblingData={siblingData}
              lighten={!column.isCurrentMonth}
              readonly={readonly}
              isCentered
              canReset={canReset}
              onShiftChange={onShiftChange}
            />
          ) : (
            !readonly && <CCShiftEmptyCell dropdownList={dropdownList} onShiftChange={onShiftChange} />
          )}
        </div>
      ) : (
        <div className="relative mx-2 mb-2 rounded overflow-hidden">
          <button
            disabled={disabled}
            className={cn('flex flex-col gap-1.5 w-full', {
              [shiftButtonHoverClassname]: !disabled,
              'opacity-60': !column.isCurrentMonth,
            })}
          >
            {onCallResources?.map((r) => <PCCOnCallResourceCellItem key={r.id} isMe={myId === r.id} resource={r} />)}
          </button>
        </div>
      )}
    </DayGridCellWrapper>
  );
};
